export var LAB_STATUS;
(function (LAB_STATUS) {
    /**
     * 已创建
     */
    LAB_STATUS["INIT"] = "init";
    /**
     * 待审核
     */
    LAB_STATUS["REVIEW"] = "review";
    /**
     * 已拒绝
     */
    LAB_STATUS["REJECTED"] = "rejected";
    /**
     * 审核通过
     */
    LAB_STATUS["APPROVED"] = "approved";
    /**
     * 已下架
     */
    LAB_STATUS["OFFLINE"] = "offline";
    /**
    * 回复
    */
    LAB_STATUS["REPLY"] = "reply";
    /**
     * 已删除
     */
    LAB_STATUS["DELETED"] = "deleted";
    /**
    * 正式功能
    */
    LAB_STATUS["OFFICIAL"] = "official";
})(LAB_STATUS || (LAB_STATUS = {}));
export const labStatusVariant = {
    [LAB_STATUS.INIT]: 'primary',
    [LAB_STATUS.REVIEW]: 'warning',
    [LAB_STATUS.REJECTED]: 'danger',
    [LAB_STATUS.APPROVED]: 'success',
    [LAB_STATUS.OFFICIAL]: 'success',
    [LAB_STATUS.OFFLINE]: 'secondary',
};
export const labAffectPageBase = [
    'Patent View',
    'Workspace',
    'Home',
    'Account',
    'SSO Login',
    'Search Result: Patent',
    'Insights Dashboard',
    'Dashboard Analysis'
];
export const labAffectProductsBase = [
    'Analytics',
    'Academy',
    'Account',
    'BIO',
    'Chemical',
    'Dashboard',
    'Discovery',
    'Help Center',
    'Home',
    'Insights',
    'Synapse',
    'Workspace'
];
// #endregion
export const TimeGranularity = [
    {
        label: 'patsnapLab.day',
        value: 'day',
    },
    {
        label: 'patsnapLab.week',
        value: 'week',
    },
    {
        label: 'patsnapLab.month',
        value: 'month',
    }
];
